import { Download } from 'lucide-react';
import { selectCurrentId } from '@gandi/redux-sharing';
import { useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { StatusIcon } from './StatusIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "OrderStatusHeader-root_10rS9",
  "markdownContent": "OrderStatusHeader-markdownContent_q8WH7"
};
const offlinePayment = ['check', 'mandate', 'transfer'];
export function OrderStatusHeader({
  adminURL,
  content,
  icon,
  order,
  title
}) {
  const {
    __
  } = useTranslator();
  const currentContent = typeof content !== 'string' ? {
    dangerouslySetInnerHTML: content
  } : {
    children: content
  };
  const sharingId = useAppSelector(selectCurrentId);
  const showProformaDownload = !!order && offlinePayment.includes(order.payment_type);
  const href = showProformaDownload && adminURL && order && `${adminURL}/billing/${sharingId}/proforma/${order.id}/pdf`;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsx(StatusIcon, {
      iconName: icon
    }), /*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexCol: true,
      gap: "spacing-4x",
      children: [/*#__PURE__*/_jsxs(Base, {
        flex: true,
        flexCol: true,
        gap: "spacing-1x",
        children: [/*#__PURE__*/_jsx(Base, {
          weight: "semibold",
          tagName: "p",
          size: "bigger",
          margin: "none",
          children: title
        }), /*#__PURE__*/_jsx(Base, {
          tagName: "p",
          margin: "none",
          className: styles.markdownContent,
          ...currentContent
        })]
      }), href && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(Button, {
          href: href,
          target: "_blank",
          type: "button",
          kind: "outline",
          rel: "noopener",
          children: [/*#__PURE__*/_jsx(Download, {}), __('Download proforma')]
        })
      })]
    })]
  });
}